import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { num_word } from 'vpl.tas';

import { CatalogInnerSections } from 'vpl.tas.listing';
import { CatalogItems } from 'vpl.tas.listing';
import { SmartFilter } from 'vpl.tas.listing';
import { BrandList } from './brandlist';



export const CatalogSectionPage = {
    components: {
        CatalogInnerSections,
        BrandList,
        SmartFilter,
        CatalogItems
    },
    props: {
        structKey: [String, Number]
    },
    methods: {

    },
    updated(){

    },
    mounted(){

    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    /*
    список разделов над товарами и фильтром
    <CatalogInnerSections :structKey="this.structKey" />

    список брендов
    <BrandList :structKey="this.structKey" />

    вставлять над дивом js-catalog-wp
    */
    template: `
        <section class="section section--first">
            <div class="container">
                <div v-if="this.struct[this.structKey].componentData.DESCRIPTION_TOP" class="text-block content catalog-text-top" v-html="this.struct[this.structKey].componentData.DESCRIPTION_TOP">
                </div>
                <div class="catalog-wp">

                    <div class="catalog__bottom js-catalog-wp">
                        <SmartFilter :structKey="this.structKey" />
                        <CatalogItems :structKey="this.structKey" />
                    </div>
                </div>
            </div>
        </section>
        <section v-if="this.struct[this.structKey].componentData.DESCRIPTION && this.struct[this.structKey].componentData.IS_MIRROR" class="section catalog-text-bottom-section">
            <div class="container">
                <div class="text-block content catalog-text-bottom" v-html="this.struct[this.structKey].componentData.DESCRIPTION">
                </div>
            </div>
        </section>
        <section v-else-if="this.struct[this.structKey].componentData.DESCRIPTION" class="section section--gray2">
            <div class="container">
                <div class="text-block content" v-html="this.struct[this.structKey].componentData.DESCRIPTION">
                </div>
            </div>
        </section>
`
}